module.exports = __webpack_public_path__ + "img/student_21.36655dcd.png";